/**
 * Hand-coded emergencies and safety situational phrases
 * (ESL → Japanese L1 kana).
 * License: CC BY-SA 4.0.
 */

import type { SituationCard } from '../../situations/types.js';

const emergenciesSafety: SituationCard[] = [
  {
    id: 'emergencies-safety.help',
    situationId: 'emergencies-safety.help',
    front: 'Help! I need help, please!',
    back: '助けてください！',
    category: 'emergencies-safety',
    cefr: 'A1',
    translations: { ja: 'たすけてください！' },
    speechAct: 'request',
    formality: 'casual',
    channel: 'in-person'
  },
  {
    id: 'emergencies-safety.call-911',
    situationId: 'emergencies-safety.call-911',
    front: "Please call 911 — this is an emergency!",
    back: '911に電話してください。緊急事態です！',
    category: 'emergencies-safety',
    cefr: 'A1',
    translations: { ja: '９１１にでんわしてください。きんきゅうじたいです！' },
    speechAct: 'request',
    formality: 'casual',
    channel: 'in-person',
    pragmaticNote: {
      en: 'In the US: 911 is police/fire/ambulance. UK: 999. EU/Japan: 112 works internationally on cell phones.',
      ja: 'アメリカでは緊急通報番号は911（警察・消防・救急）、英国は999、EU・日本は携帯電話なら112も国際共通。'
    }
  },
  {
    id: 'emergencies-safety.lost-passport',
    situationId: 'emergencies-safety.lost-passport',
    front: "I've lost my passport — what should I do?",
    back: 'パスポートをなくしてしまいました……どうすればいいですか？',
    category: 'emergencies-safety',
    cefr: 'A2',
    translations: { ja: 'パスポートをなくしてしまいました……どうすればいいですか？' },
    speechAct: 'request',
    formality: 'polite',
    channel: 'in-person'
  },
  {
    id: 'emergencies-safety.report-accident',
    situationId: 'emergencies-safety.report-accident',
    front: "There's been an accident — someone is hurt. We need an ambulance.",
    back: '事故がありました。けが人がいます。救急車を呼んでください。',
    category: 'emergencies-safety',
    cefr: 'A2',
    translations: { ja: 'じこがありました。けがにんがいます。きゅうきゅうしゃをよんでください。' },
    speechAct: 'request',
    formality: 'casual',
    channel: 'phone'
  },
  {
    id: 'emergencies-safety.contact-embassy',
    situationId: 'emergencies-safety.contact-embassy',
    front: "I'd like to contact the Japanese embassy, please.",
    back: '日本大使館に連絡を取りたいのですが。',
    category: 'emergencies-safety',
    cefr: 'B1',
    translations: { ja: 'にほんたいしかんにれんらくをとりたいのですが。' },
    speechAct: 'request',
    formality: 'polite',
    channel: 'in-person'
  },
  {
    id: 'emergencies-safety.stolen-wallet',
    situationId: 'emergencies-safety.stolen-wallet',
    front: "My wallet was stolen — I need to report it to the police.",
    back: '財布を盗まれました。警察に届けたいのですが。',
    category: 'emergencies-safety',
    cefr: 'B1',
    translations: { ja: 'さいふをぬすまれました。けいさつにとどけたいのですが。' },
    speechAct: 'request',
    formality: 'polite',
    channel: 'in-person'
  },
  {
    id: 'emergencies-safety.fire',
    situationId: 'emergencies-safety.fire',
    front: 'There\'s a fire on the second floor — everyone needs to evacuate now!',
    back: '二階で火事が起きています！すぐに避難してください！',
    category: 'emergencies-safety',
    cefr: 'B1',
    translations: { ja: 'にかいでかじがおきています！すぐにひなんしてください！' },
    speechAct: 'request',
    formality: 'casual',
    channel: 'in-person'
  },
  {
    id: 'emergencies-safety.allergic-reaction',
    situationId: 'emergencies-safety.allergic-reaction',
    front: "I'm having an allergic reaction — I need my EpiPen and an ambulance.",
    back: 'アレルギー反応が出ています。エピペンと救急車を呼んでください。',
    category: 'emergencies-safety',
    cefr: 'B2',
    translations: { ja: 'アレルギーはんのうがでています。エピペンときゅうきゅうしゃをよんでください。' },
    speechAct: 'request',
    formality: 'casual',
    channel: 'in-person'
  },
  {
    id: 'emergencies-safety.lost-child',
    situationId: 'emergencies-safety.lost-child',
    front: "I can't find my daughter — she was with me five minutes ago. Could you help me look?",
    back: '娘が見当たらないんです。5分前まで一緒にいたのですが、探していただけますか？',
    category: 'emergencies-safety',
    cefr: 'B2',
    translations: { ja: 'むすめがみあたらないんです。５ふんまえまでいっしょにいたのですが、さがしていただけますか？' },
    speechAct: 'request',
    formality: 'polite',
    channel: 'in-person'
  },
  {
    id: 'emergencies-safety.report-suspicious',
    situationId: 'emergencies-safety.report-suspicious',
    front: "I\'d like to report something suspicious — there's an unattended bag at the station.",
    back: '不審物を通報したいのですが。駅に置きっぱなしの荷物があります。',
    category: 'emergencies-safety',
    cefr: 'B1',
    translations: { ja: 'ふしんぶつをつうほうしたいのですが。えきにおきっぱなしのにもつがあります。' },
    speechAct: 'request',
    formality: 'polite',
    channel: 'phone'
  }
];

export default emergenciesSafety;
